export const USERNAME_FOUND = 'USERNAME_FOUND'
export const USERNAME_NOT_FOUND = 'USERNAME_NOT_FOUND'

export const USER_ID = 'USER_ID'

export const EVENT_USER_ID = 'EVENT_USER_ID'
export const SET_USER_COUNTRY = 'SET_USER_COUNTRY'
export const SET_NO_VIEWERS = 'SET_NO_VIEWERS'